/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable class-methods-use-this */

import * as Services from '@services';
import { EntityDto } from '@services';
import { makeAutoObservable, runInAction } from 'mobx';
import * as technicalCategory from 'services/technicalCategory';
import { TechnicalCategory, TechnicalCategoryBookmark } from 'services/technicalCategory';

class TechnicalCategoryStore {
  pagedCategories: Services.PagedResultDto<technicalCategory.TechnicalCategory> = {
    totalCount: 0,
    items: [],
  };
  pagedBookmarks: Services.PagedResultDto<technicalCategory.TechnicalCategoryBookmark> = {
    totalCount: 0,
    items: [],
  };
  categories: TechnicalCategory[] = [];
  subCategories: any[] = [];
  subCategoriesLoading: boolean = false;
  selectedCategoryId: string = '';
  selectedBookmark: TechnicalCategoryBookmark | undefined;
  bookmarked: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  async getAllCategories(request: Services.PagedTechnicalCategoryRequest) {
    try {
      const result = await Services.TechnicalCategoryService.getAllCategories(request);
      this.pagedCategories = result;
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  }

  async getCategoriesByVinAndCategory(request: Services.TechnicalCategoryRequest) {
    this.setSubCategoriesLoading(true);
    try {
      const result = await Services.TechnicalCategoryService.getCategoriesByVinAndCategory(request);
      this.categories = result;
    } catch (error) {
      console.error('Error fetching categories by VIN and category:', error);
    } finally {
      this.setSubCategoriesLoading(false);
    }
  }

  async getSubCategoriesByCategoryId(request: Services.EntityDto<string>) {
    this.setSubCategoriesLoading(true);
    try {
      const result = await Services.TechnicalCategoryService.getSubCategoriesByCategoryId(request);
      this.subCategories = result.sort((a, b) =>
        a.order > b.order ? 1 : b.order > a.order ? -1 : 0
      );
      this.selectedCategoryId = request.id;
    } catch (error) {
      console.error('Error fetching subcategories:', error);
    } finally {
      this.setSubCategoriesLoading(false);
    }
  }

  async getAllBookmarks(request: Services.PagedTechnicalCategoryBookmarkRequest) {
    const result =
      await Services.TechnicalCategoryService.getAllTechnicalCategoryBookmarks(request);
    this.pagedBookmarks = result;
  }

  async getTechnicalCategoryBookmark(request: Services.TechnicalCategoryBookmarkRequest) {
    try {
      const result = await Services.TechnicalCategoryService.getTechnicalCategoryBookmark(request);
      this.selectedBookmark = result;
      this.bookmarked = result ? true : false;
    } catch (error) {
      console.error('Error fetching technical category bookmark:', error);
    }
  }

  async createTechnicalCategoryBookmark(request: Services.TechnicalCategoryBookmarkRequest) {
    try {
      await this.getTechnicalCategoryBookmark(request);
      const result =
        await Services.TechnicalCategoryService.createTechnicalCategoryBookmark(request);
      this.bookmarked = true;
      this.pagedBookmarks.items = [result].concat(this.pagedBookmarks.items);
      this.pagedBookmarks.totalCount += 1;
    } catch (error) {
      console.error('Error creating bookmark:', error);
    }
  }

  async removeBookmark(entityDto: EntityDto<string>) {
    await Services.TechnicalCategoryService.removeTechnicalCategoryBookmark(entityDto);
    this.bookmarked = false;
    this.pagedBookmarks.items = this.pagedBookmarks.items.filter((x) => x.id !== entityDto.id);
    this.pagedBookmarks.totalCount -= 1;
  }

  setSubCategoriesLoading = (loading: boolean) => {
    runInAction(() => {
      this.subCategoriesLoading = loading;
    });
  };

  clearSubCategories = () => (this.subCategories = []);

  clearSelectedCategory = () => (this.selectedCategoryId = '');

  clearPagedCategories = () => (this.pagedCategories.items = []);

  clearPagedBookmarks = () => (this.pagedBookmarks.items = []);

  setSelectedBookmark = (bookmark: TechnicalCategoryBookmark) => (this.selectedBookmark = bookmark);
}

export default TechnicalCategoryStore;
